import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Upload, Sparkles } from 'lucide-react';
import SampleDataButton from './SampleDataButton';

const EmptyState = ({ lane, onSampleLoaded, showSampleButton = true }) => {
  const navigate = useNavigate();

  const getLaneConfig = () => {
    switch (lane) {
      case 'build_next':
        return {
          icon: '🚀',
          title: 'No opportunities yet',
          description: 'Add signals to discover what to build for maximum revenue impact.',
        };
      case 'fix_now':
        return {
          icon: '⚠️',
          title: 'No urgent issues',
          description: 'Add signals to catch churn risks and critical bugs before they impact revenue.',
        };
      case 'ignore':
        return {
          icon: '❌',
          title: 'No noise filtered yet',
          description: 'When new signals arrive, low-priority items will appear here automatically.',
        };
      default:
        return {
          icon: '📦',
          title: 'No items',
          description: 'Add signals to get started.',
        };
    }
  };

  const config = getLaneConfig();

  return (
    <div
      className="flex flex-col items-center justify-center text-center p-8 min-h-[300px]"
      data-testid={`empty-state-${lane}`}
    >
      <div className="text-6xl mb-4 opacity-50">{config.icon}</div>
      <h3 className="text-lg font-semibold mb-2 text-foreground">{config.title}</h3>
      <p className="text-sm text-muted-foreground mb-6 max-w-xs">{config.description}</p>

      <div className="flex flex-col gap-2 w-full max-w-[220px]" data-tour="sample-data">
        <Button
          onClick={() => navigate('/import')}
          className="btn-cta gap-2"
          data-testid={`empty-state-${lane}-import-button`}
        >
          <Upload className="h-4 w-4" />
          Add signals
        </Button>
        {showSampleButton && (
          <SampleDataButton
            variant="outline"
            size="default"
            label="Try sample data"
            onSuccess={onSampleLoaded}
          />
        )}
      </div>

      {showSampleButton && lane === 'build_next' && (
        <p className="text-xs text-muted-foreground mt-4 flex items-center gap-1">
          <Sparkles className="h-3 w-3" />
          Sample data won't count toward your AI quota
        </p>
      )}
    </div>
  );
};

export default EmptyState;
